// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__O67Gl","logoWrapper":"Footer_logoWrapper__Az2hK","rights":"Footer_rights__fQz9c","designLink":"Footer_designLink__ZWDv7"};